<div class=" text-center">
	<div class="flex justify-content-center gap-2 align-items-center">
		<p-button icon="pi pi-chevron-left" styleClass="p-button-rounded p-button-text" (click)="setYear(-1)"></p-button>
		<span>{{year}}</span>
		<p-button icon="pi pi-chevron-right" styleClass="p-button-rounded p-button-text" (click)="setYear(+1)"></p-button>
	</div>
	<div *ngFor="let e of events" class="mt-5 event">
		<div class="grid grid-nogutter h-full">
			<div class="col-7 h-full  p-4">
				<h2 class="my-3">{{e.title}}</h2>
				<div class="font-bold text-sm">
					<span *ngIf="e.start ">Du </span>{{e.start | date:'EEE dd MMM YYYY'}} 
					<span *ngIf="e.end">au </span>{{e.end | date:'EEE dd MMM YYYY'}}
				</div>
			</div>
			<div class="col-5 h-full flex flex-column justify-content-center align-items-center bg-white" *ngIf="e.cover">
				<img class="max-w-full"  src="https://blackrockgames.fr/upload/thumbd.php?id={{e.cover}}&size=w480h320"  *ngIf="e.cover"
				/>
			</div>
		</div>
	</div>
</div>